<div class="flex flex-col gap-[24px] lt-md:gap-[16px]">
  <h2 data-at-title>
    {{ '+BOOKING.OVERVIEW.CONTINGENT_SUBSCRIPTIONS.TITLE' | translate }}
  </h2>

  <div class="contingent-subscriptions-container">
    <app-booking-contingent-subscription-details
      *ngFor="let contingentSubscription of contingentSubscriptions"
      [contingentSubscription]="contingentSubscription"
    ></app-booking-contingent-subscription-details>
  </div>
</div>
